<template>
  <page>
    <div slot="pageAction">
      <div class="actionBlock">
        <v-menu offset-y :min-width="250">
          <template v-slot:activator="{ on }">
            <v-btn text color="secondary" v-on="on">
              Related Tasks
              <v-icon right>mdi-link</v-icon>
            </v-btn>
          </template>
          <side-function-menu :items="sideFunction" @doClick="$router.push($event)"></side-function-menu>
        </v-menu>
      </div>
    </div>
    <div>
      <v-flex xs12>
        <form>
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-lg>
                      <v-layout row wrap>
                        <v-flex xl3 lg6 xs6>
                          <v-text-field
                            v-model="filters.stdRiskTxtRef"
                            :label="labels.stdRiskTxtRef"
                            :error-messages="errors.collect('stdRiskTxtRef')"
                            data-vv-name="stdRiskTxtRef"
                            :data-vv-as="labels.stdRiskTxtRef"
                            v-validate="'name|max:3'"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xl3 lg6 xs6>
                          <v-text-field
                            v-model="filters.stdRiskTxtLn"
                            :label="labels.stdRiskTxtLn"
                            :error-messages="errors.collect('stdRiskTxtLn')"
                            data-vv-name="stdRiskTxtLn"
                            :data-vv-as="labels.stdRiskTxtLn"
                            v-validate="'name|max:1000'"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </form>
      </v-flex>
      <v-spacer class="mt-2"></v-spacer>
      <v-card>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
        <v-card-title>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click.native="doNewStdRiskTxt()"> New Standard Risk Text<v-icon right>mdi-plus</v-icon> </v-btn>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="items"
          v-bind:options.sync="pagination"
          :server-items-length="totalItems"
          :loading="loading"
          :footer-props="{'items-per-page-options': itemsPerPage }"
          :no-data-text="noDataText"
        >
          <template v-slot:item="row"
            ><tr>
              <td>{{ row.item.stdRiskTxtRef }}</td>
              <td class="text-xs-left">{{ row.item.stdRiskTxtLn }}</td>
              <td class="table-action-header">
                <table-action
                  :rowData="row"
                  review
                  @review="doStdRiskTxtReview(row.item.stdRiskTxtRef)"
                  remove
                  @remove="doPromptRemove(row.item)"
                ></table-action>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
      <confirm v-model="promptRemove" @ok="doRemove">
        Are you sure that you want to delete the selected Standard Risk Text? {{ deleteStdRiskTxt }}
      </confirm>
    </div>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'
import SideFunctionMenu from '@/components/core/claimManagement/sideFunction/SideFunctionMenu'

export default {
  data() {
    return {
      sideFunction: [
        {
          text: 'Default Standard Risk Text',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'defStdRiskTxt' }
        },
        {
          text: 'Standard Item Text Default Benefit',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'stdItemTxtDefBen' }
        }
      ],
      toogleArray: [false],
      headers: [
        { text: 'Text Ref', align: 'left', value: 'stdRiskTxtRef' },
        { text: 'Text Line', value: 'stdRiskTxtLn' },
        TableConst.tableActionHeader
      ],
      labels: {
        stdRiskTxtRef: 'Standard Risk Text Ref',
        stdRiskTxtLn: 'Standard Risk Text Line'
      },
      filters: {
        stdRiskTxtRef: undefined,
        stdRiskTxtLn: undefined
      },
      totalItems: 0,
      selectedStdRiskTxtRef: undefined,
      deleteStdRiskTxt: '',
      loading: false,
      promptRemove: false,
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  watch: {
    'pagination': function (value) {
      this.doInit(false)
    }
  },
  computed: {
    stdRiskTxtRefMenu() {
      return this.$store.state.StdRiskTxtParam.menu
    }
  },
  methods: {
    async doInit(options) {
      this.resetMessages()
      const apiURI = this.stdRiskTxtRefMenu.getStdRiskTxtList
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), this.filters, this.pagination.sortBy, this.pagination.sortDesc))
          if (result) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            this.items = []
            if (data) {
              data.map((stdRiskTxtdatamap) => {
                const convertList = {
                  stdRiskTxtRef: stdRiskTxtdatamap.stdRiskTxtRef,
                  stdRiskTxtLn: stdRiskTxtdatamap.stdRiskTxtLn
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    },
    doClearFilters() {
      this.resetMessages()
      this.filters.stdRiskTxtRef = null
      this.filters.stdRiskTxtLn = null
      this.pagination.page = 1
      this.doInit(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.pagination.page = 1
          this.doInit(false)
        }
      })
    },
    doStdRiskTxtReview(stdrisktxt) {
      this.$router.push({ name: 'stdRiskTxtReview', params: { stdrisktxt: stdrisktxt } })
    },
    doNewStdRiskTxt() {
      this.$router.push({ name: 'stdRiskTxtReview', params: { stdrisktxt: 'new' } })
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedStdRiskTxtRef = data
        this.deleteStdRiskTxt = data.stdRiskTxtRef
      }
    },
    async doRemove() {
      const apiURI = this.stdRiskTxtRefMenu.deleteStdRiskTxt
      if (apiURI) {
        const expand = this.selectedStdRiskTxtRef
        this.$http
          .post(apiURI, expand)
          .then((result) => {
            const data = result.data
            this.notify(data)
            this.doInit(true)
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
            }
          })
      }
    }
  },
  created() {},
  mounted() {
    this.doInit(true)
  },
  components: {
    SideFunctionMenu
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>
